var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18.3335 16.6667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.50007 4.99724C2.3634 4.99371 2.26415 4.9858 2.17492 4.96805C1.51377 4.83654 0.996942 4.31971 0.865431 3.65856C0.833406 3.49756 0.833406 3.30395 0.833406 2.91674C0.833406 2.52953 0.833406 2.33592 0.865431 2.17492C0.996942 1.51377 1.51377 0.996942 2.17492 0.865431C2.33592 0.833406 2.52953 0.833406 2.91674 0.833406H15.4167C15.804 0.833406 15.9976 0.833406 16.1586 0.865431C16.8197 0.996942 17.3365 1.51377 17.468 2.17492C17.5001 2.33592 17.5001 2.52953 17.5001 2.91674C17.5001 3.30395 17.5001 3.49756 17.468 3.65856C17.3365 4.31971 16.8197 4.83654 16.1586 4.96805C16.0693 4.9858 15.9701 4.99371 15.8334 4.99724M7.50007 9.16674H10.8334M2.50007 5.00007H15.8334V11.8334C15.8334 13.2335 15.8334 13.9336 15.5609 14.4684C15.3212 14.9388 14.9388 15.3212 14.4684 15.5609C13.9336 15.8334 13.2335 15.8334 11.8334 15.8334H6.50007C5.09994 15.8334 4.39988 15.8334 3.8651 15.5609C3.39469 15.3212 3.01224 14.9388 2.77256 14.4684C2.50007 13.9336 2.50007 13.2335 2.50007 11.8334V5.00007Z",
    stroke: "var(--stroke-0, black)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.2cf94c242907a3d0855e87d9dd4c9474.svg";
export { ForwardRef as ReactComponent };